import getStore, { GeneratingState } from '../store/store';

export function isCopilotHeadlinesStarted(): boolean {
    return getStore().generatingState !== GeneratingState.NotStarted;
}
